import type { MotifComponent, MotifComponentProps } from '../../../motif';
import { m } from '../../../motif/m';

/**
 * Jira ticket: https://jira.sc-corp.net/browse/WEBP-9704 The following value for TableCellMinWidth
 * is dictated by design
 */
const tableCellMinWidth = '156px';

const tableCellDesktopPadding = `${m('--spacing-xl')} ${m('--spacing-m')}`;
const tableCellMobilePadding = `${m('--spacing-xxs')} ${m('--spacing-m')}`;

export const primitiveTableYellowBgVars: MotifComponentProps<MotifComponent.PRIMITIVE_TABLE> = {
  '--table-bg-color': m('--neutral-v0'),
  '--table-border-color': m('--neutral-v300'),
  '--table-cell-body-bg-color': m('--neutral-v0'),
  '--table-cell-desktop-padding': tableCellDesktopPadding,
  '--table-cell-fg-color': m('--neutral-v500'),
  '--table-cell-header-bg-color': m('--neutral-v300'),
  '--table-cell-min-width': tableCellMinWidth,
  '--table-cell-mobile-padding': tableCellMobilePadding,
  '--table-desktop-row-gap': '0',
  '--table-first-column-max-width': 'max-content',
  '--table-header-fg-color': m('--fg-color'),
  '--table-mobile-row-gap': m('--spacing-l'),
} as const;

export const primitiveTableLightBgVars: MotifComponentProps<MotifComponent.PRIMITIVE_TABLE> = {
  '--table-bg-color': 'transparent',
  '--table-border-color': m('--neutral-v200'),
  '--table-cell-body-bg-color': m('--neutral-v0'),
  '--table-cell-desktop-padding': tableCellDesktopPadding,
  '--table-cell-fg-color': m('--neutral-v500'),
  '--table-cell-header-bg-color': m('--neutral-v200'),
  '--table-cell-min-width': tableCellMinWidth,
  '--table-cell-mobile-padding': tableCellMobilePadding,
  '--table-desktop-row-gap': '0',
  '--table-first-column-max-width': 'max-content',
  '--table-header-fg-color': m('--fg-color'),
  '--table-mobile-row-gap': m('--spacing-l'),
} as const;

export const primitiveTableDarkBgVars: MotifComponentProps<MotifComponent.PRIMITIVE_TABLE> = {
  '--table-bg-color': 'transparent',
  '--table-border-color': m('--neutral-v600'),
  '--table-cell-body-bg-color': m('--neutral-v700'),
  '--table-cell-desktop-padding': tableCellDesktopPadding,
  '--table-cell-fg-color': m('--neutral-v200'),
  '--table-cell-header-bg-color': m('--neutral-v600'),
  '--table-cell-min-width': tableCellMinWidth,
  '--table-cell-mobile-padding': tableCellMobilePadding,
  '--table-desktop-row-gap': '0',
  '--table-first-column-max-width': 'max-content',
  '--table-header-fg-color': m('--fg-color'),
  '--table-mobile-row-gap': m('--spacing-l'),
} as const;

export const primitiveTableGrayBgVars: MotifComponentProps<MotifComponent.PRIMITIVE_TABLE> = {
  '--table-bg-color': 'transparent',
  '--table-border-color': m('--neutral-v250'),
  '--table-cell-body-bg-color': m('--neutral-v150'),
  '--table-cell-desktop-padding': tableCellDesktopPadding,
  '--table-cell-fg-color': m('--neutral-v500'),
  '--table-cell-header-bg-color': m('--neutral-v250'),
  '--table-cell-min-width': tableCellMinWidth,
  '--table-cell-mobile-padding': tableCellMobilePadding,
  '--table-desktop-row-gap': '0',
  '--table-first-column-max-width': 'max-content',
  '--table-header-fg-color': m('--fg-color'),
  '--table-mobile-row-gap': m('--spacing-l'),
} as const;
